var _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.864 82.901 c -0.189 0 -0.38 -0.037 -0.561 -0.113 c -0.539 -0.226 -0.89 -0.754 -0.89 -1.339 V 71.5 H 3.755 C 1.685 71.5 0 69.815 0 67.745 V 34.296 c 0 -2.071 1.685 -3.755 3.755 -3.755 h 49.673 c 2.07 0 3.755 1.685 3.755 3.755 v 33.449 c 0 2.07 -1.685 3.755 -3.755 3.755 H 22.075 L 10.881 82.485 C 10.604 82.757 10.237 82.901 9.864 82.901 z M 3.755 33.444 c -0.47 0 -0.852 0.382 -0.852 0.852 v 33.449 c 0 0.47 0.382 0.852 0.852 0.852 h 6.109 c 0.802 0 1.452 0.65 1.452 1.452 v 7.943 l 9.149 -8.979 c 0.272 -0.266 0.636 -0.416 1.017 -0.416 h 31.947 c 0.47 0 0.852 -0.382 0.852 -0.852 V 34.296 c 0 -0.47 -0.382 -0.852 -0.852 -0.852 H 3.755 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(136,136,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 44.27,
    rx: 0,
    ry: 0,
    width: 32.69,
    height: 2.9,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(136,136,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 53.95,
    rx: 0,
    ry: 0,
    width: 32.69,
    height: 2.9,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(136,136,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80.136 59.459 c -0.373 0 -0.74 -0.144 -1.017 -0.416 L 67.925 48.058 h -6.041 v -2.903 h 6.634 c 0.38 0 0.745 0.149 1.017 0.416 l 9.148 8.979 v -7.943 c 0 -0.802 0.65 -1.452 1.452 -1.452 h 6.109 c 0.47 0 0.852 -0.382 0.852 -0.852 V 10.854 c 0 -0.47 -0.382 -0.852 -0.852 -0.852 H 36.572 c -0.47 0 -0.852 0.382 -0.852 0.852 v 13.98 h -2.903 v -13.98 c 0 -2.07 1.685 -3.755 3.755 -3.755 h 49.673 c 2.07 0 3.755 1.685 3.755 3.755 v 33.449 c 0 2.07 -1.685 3.755 -3.755 3.755 h -4.658 v 9.95 c 0 0.585 -0.351 1.112 -0.89 1.339 C 80.516 59.423 80.325 59.459 80.136 59.459 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(136,136,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.06,
    y: 20.83,
    rx: 0,
    ry: 0,
    width: 32.69,
    height: 2.9,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(136,136,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.98,
    y: 30.5,
    rx: 0,
    ry: 0,
    width: 13.77,
    height: 2.9,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(136,136,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ae778a578ccd4146e52634ae8ee0d092.svg";
export { ForwardRef as ReactComponent };